module.exports = __webpack_public_path__ + "img/QuilityLogoVerticalBlackRGB.b89d5975.svg";